export const defaultReplaceMap: [string, string][] = [
  ['(\\d+(?:\\.\\d+)?)"', "$1 inch"],
  ["(\\d+(?:\\.\\d+)?)in", "$1 inch"],
  ["(\\d+(?:\\.\\d+)?)oz", "$1 ounce"],
  ["\\boz\\b", "ounce"],
  ["(\\d+(?:\\.\\d+)?)l", "$1 liter"],
  ["(\\d+)\\s*wings\\b", "$1 piece wings"],
  ["&", "and"],
  ["\\*", ""],
  ["w\\/", "with"],
  ["1\\/2", "half"],
  ["\\bny\\b", "new york"],
  ["\\bpc\\b", "piece"],
  ["bbq", "barbecue"],
  ["add on.*", "additions"],
  [".mod.", "mods"],
  ["1\\/4", "quarter"],
  ["1\\/3", "third"],
];

export const defaultMenuModuleConfig = {
  enabled: true,
  locked: false,

  categoryBlacklist: {},
  categoryNameOverrides: {},
  categoryDescriptionOverrides: {},
  categoryAvailabilityOverrides: {},
  categoryFilter: [],
  categoryWhitelist: false,
  categoryPrepTimeOverrides: {},

  itemBlacklist: {},
  itemNameOverrides: {},
  itemDescriptionOverrides: {},
  itemAvailabilityOverrides: {},
  defaultOptionsOverrides: {},
  itemPrepTimeOverrides: {},
  notesMap: {},

  modifierBlacklist: {},
  modifierNameOverrides: {},
  forceRequired: {},
  freeModifierCount: {},
  freeModifierCountV2: {},
  allowStackedOverrides: {},

  optionBlacklist: {},
  optionNameOverrides: {},

  manualMenu: [],
  replaceMap: defaultReplaceMap,
};

// Form-specific default values that match the form schema
export const defaultMenuModuleFormConfig = {
  menuEnabled: true,
  menuLocked: false,
  manualMenu: [],
  menuReplaceMap: defaultReplaceMap,
};
